import React, { useState } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F';
const s = {
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'10px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
  btn:{padding:'12px 22px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
};

export default function Register({ onRegister, onBack }) {
  const [form, setForm] = useState({ first_name:'', last_name:'', email:'', phone:'', password:'', confirm_password:'' });
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const nfcToken = params.get('nfc_token') || localStorage.getItem('pending_nfc_token') || '';

  const submit = async () => {
    if (!form.first_name || !form.last_name || !form.email || !form.password) {
      setMsg('Completeaza toate campurile obligatorii!'); return;
    }
    if (form.password !== form.confirm_password) {
      setMsg('Parolele nu coincid!'); return;
    }
    if (form.password.length < 6) {
      setMsg('Parola trebuie sa aiba minim 6 caractere!'); return;
    }
    setLoading(true);
    const res = await fetch('/api/auth/register', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ first_name: form.first_name, last_name: form.last_name, email: form.email, phone: form.phone, password: form.password })
    });
    const data = await res.json();
    if (data.token) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      if (nfcToken && data.user) {
        await fetch('/api/public/nfc/activate', {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ nfc_token: nfcToken, user_id: data.user.id, destination: 'account' }),
        });
        localStorage.removeItem('pending_nfc_token');
      }
      onRegister(data.user);
    } else if (data.message) {
      setDone(true);
    } else {
      setMsg(data.error || 'Eroare la inregistrare');
    }
    setLoading(false);
  };

  if (done) return (
    <div style={{minHeight:'100vh',background:'#F4F4F4',fontFamily:"'Syne',sans-serif",display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'#fff',borderRadius:'16px',padding:'40px',maxWidth:'460px',width:'100%',textAlign:'center',border:'0.5px solid #D3D1C7'}}>
        <div style={{fontSize:'56px',marginBottom:'16px'}}>📧</div>
        <div style={{fontSize:'22px',fontWeight:800,marginBottom:'10px'}}>Verifica emailul!</div>
        <div style={{fontSize:'14px',color:'#555',lineHeight:1.7,marginBottom:'20px'}}>
          Am trimis un email de confirmare la<br/>
          <strong style={{color:NAVY}}>{form.email}</strong><br/><br/>
          Apasa link-ul din email pentru a-ti activa contul si a accesa dosarmasina.ro.
        </div>
        <div style={{background:'#FEF3DC',border:'1px solid '+GOLD,borderRadius:'10px',padding:'12px',fontSize:'12px',color:'#D97706',marginBottom:'20px'}}>
          ⏰ Link-ul este valabil <strong>24 de ore</strong>. Verifica si folderul Spam.
        </div>
        <button onClick={onBack} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',width:'100%'}}>
          ← Inapoi la login
        </button>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:'100vh',background:'#F4F4F4',fontFamily:"'Syne',sans-serif",display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'#fff',borderRadius:'16px',padding:'32px',maxWidth:'460px',width:'100%',border:'0.5px solid #D3D1C7'}}>
        <div style={{textAlign:'center',marginBottom:'24px'}}>
          <div style={{background:DARK,width:'50px',height:'50px',borderRadius:'12px',display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:'12px'}}>
            <span style={{color:GOLD,fontWeight:900,fontSize:'16px'}}>EA</span>
          </div>
          <div style={{fontSize:'20px',fontWeight:800,marginBottom:'4px'}}>Creeaza cont nou</div>
          <div style={{fontSize:'12px',color:'#888'}}>dosarmasina.ro — gestioneaza-ti masinile simplu</div>
        </div>

        {nfcToken && <div style={{background:'#FEF3DC',border:'1px solid '+GOLD,borderRadius:'8px',padding:'10px 12px',fontSize:'12px',color:'#92400E',marginBottom:'12px'}}>🏷️ Creezi contul pentru a activa tag-ul NFC.</div>}
        {msg && <div style={{background:'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:'#B91C1C',marginBottom:'12px'}}>{msg}</div>}

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'10px'}}>
          <div><label style={s.label}>Prenume *</label><input style={s.input} placeholder="Ion" value={form.first_name} onChange={e=>setForm({...form,first_name:e.target.value})}/></div>
          <div><label style={s.label}>Nume *</label><input style={s.input} placeholder="Popescu" value={form.last_name} onChange={e=>setForm({...form,last_name:e.target.value})}/></div>
        </div>
        <div style={{marginBottom:'10px'}}><label style={s.label}>Email *</label><input style={s.input} type="email" placeholder="email@exemplu.ro" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/></div>
        <div style={{marginBottom:'10px'}}><label style={s.label}>Telefon</label><input style={s.input} placeholder="07xx xxx xxx" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})}/></div>
        <div style={{marginBottom:'10px'}}><label style={s.label}>Parola *</label><input style={s.input} type="password" placeholder="Minim 6 caractere" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}/></div>
        <div style={{marginBottom:'20px'}}><label style={s.label}>Confirma parola *</label><input style={s.input} type="password" placeholder="Repeta parola" value={form.confirm_password} onChange={e=>setForm({...form,confirm_password:e.target.value})}/></div>

        <button onClick={submit} disabled={loading} style={{...s.btn,background:GOLD,color:DARK,width:'100%',marginBottom:'10px'}}>
          {loading ? 'Se creeaza contul...' : 'Creeaza cont →'}
        </button>
        <button onClick={onBack} style={{...s.btn,background:'transparent',color:'#888',width:'100%',fontSize:'12px'}}>
          ← Am deja cont
        </button>
      </div>
    </div>
  );
}
